import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Pagination } from '../../../global/types/Pagination';

@Component({
  selector: 'app-pagination-scroll-with-button',
  templateUrl: './pagination-scroll-with-button.component.html',
  styleUrls: ['./pagination-scroll-with-button.component.less'],
})
export class PaginationScrollWithButtonComponent implements OnInit {
  currentPage = 1;
  @Input() perPage = 20;
  @Input() canLoadMore = true;
  @Input() isLoading = false;
  @Input() total: number;

  @Output() loadMore = new EventEmitter<Pagination>();

  @ViewChild('buttonElement') button: ElementRef;

  constructor() {}

  ngOnInit(): void {
    this.loadMore.emit({ currentPage: this.currentPage, perPage: this.perPage });
  }

  onLoadMoreClick() {
    this.currentPage++;
    this.loadMore.emit({ currentPage: this.currentPage, perPage: this.perPage });
  }

  resetPaginationAndLoadFirstPage() {
    this.currentPage = 0;
    this.onLoadMoreClick();
  }
}
